
import Vue from "vue"
import FooterBase from "~/components/base/footerBase"

export default Vue.extend({
  name: "TheFooterIT",
  extends: FooterBase
})
